import { Component, Input } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'

@Component({
    selector: 'col-operadoras-indisponiveis-modal',
    templateUrl: './operadoras-indisponiveis-modal.component.html',
    styleUrls: ['./operadoras-indisponiveis-modal.component.scss']
})
export class OperadorasIndisponiveisModalComponent {
    @Input() operadoras: OperadoraDeMaquina[]

    constructor(private bsModalRef: BsModalRef) {}

    fechar() {
        this.bsModalRef.hide()
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/operadoras-indisponiveis-modal/operadoras-indisponiveis-modal.component.ts